import React from 'react';
import { getMarketingSiteUrl } from '../../utils/marketingNavigation';

type MarketingLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
};

/**
 * Full-page link to peppar-site (Next.js). Use instead of React Router &lt;Link&gt;
 * for marketing URLs so Nginx can serve the new landing pages.
 */
const MarketingLink: React.FC<MarketingLinkProps> = ({ href, children, ...rest }) => (
  <a href={getMarketingSiteUrl(href)} {...rest}>
    {children}
  </a>
);

export default MarketingLink;
